import { api } from './client';
import type {
  ActionItemDetailResponse,
  ActionItemListQuery,
  ActionItemListResponse,
} from '@shared/types';

export const actionItemsApi = {
  list: async (params: ActionItemListQuery = {}): Promise<ActionItemListResponse> => {
    const { data } = await api.get('/action-items', { params });
    return data;
  },

  detail: async (id: string): Promise<ActionItemDetailResponse> => {
    const { data } = await api.get(`/action-items/${id}`);
    return data;
  },

  snooze: async (id: string, until: string, reason?: string) => {
    const { data } = await api.post(`/action-items/${id}/snooze`, { until, reason });
    return data;
  },
};
